const baseURL = process.env.NODE_ENV !== 'production' ? 'http://localhost:3002/api' : '/api';
console.log(`Base URL: ${baseURL}`);
module.exports = { baseURL };